import { Component, Input, ViewContainerRef } from '@angular/core';

import { BaseComponent } from '../../../components/base.component';
import { environment } from '../../../environment';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentService } from '../../../services/document.service';
import { MapCoreDocument } from '../../../types';

@Component({
    selector: 'mc-doc-source-photo-ng',
    templateUrl: './doc-source-photo.component.html',
    styleUrls: ['./doc-source-photo.component.scss']
})
export class DocSourcePhotoComponent extends BaseComponent {

    private _document: MapCoreDocument;
    get document() {
        return this._document;
    }
    @Input()
    set document(value) {
        if (window.environment.indexOf('internal') === -1 && value && value.url && (value.url as string).indexOf('geosnap') > -1) {
            const url = value.url as string;
            value.url = environment.apiBaseUrl + url.substring(url.indexOf('geosnap') - 1, url.length);
        }
        this._document = value;
    }

    private _currentFeature: { [key: string]: any };
    get currentFeature() {
        return this._currentFeature;
    }
    @Input()
    @InputConverter(JSONConverter)
    set currentFeature(value) {
        this._currentFeature = JSONConverter(value);
    }

    get altText(): string {
        return [this.document.title, this.document.description].filter(x => x).join(' - ') || 'Image';
    }

    constructor(_vcr: ViewContainerRef, public readonly documentService: DocumentService) {
        super(_vcr);
    }

    public requestLarger() {
        if (this.document) {
            this.documentService.requestFullScreenImages([this.document]);
        }
    }
}
